import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "./NavBar/NavBar";
import Gallery from "./Gallery/Gallery";
import Cart from "./MyCart/Cart";
import Order from "./MyOrders/Order";
import About from "./About/About";
import { GlobalStatusAction } from "./Redux/GlobalStatusRedux";
import { useDispatch, useSelector } from "react-redux";
import { IsAuthValid } from "./Redux/CheckAuthRedux";
import UpdateGallery from "./UpdateGallery/UpdateGallery";
import CustomerOrders from "./CustomerOrders/CustomerOrders";

// add about US.
// Add tracing who clicked what.
// add filter Pagination etc in order & customerOrders & in tracing.

function App() {
    
  const dispatch = useDispatch();
  if (localStorage.getItem("access_token") !== null) {
    dispatch(IsAuthValid());
  }
  if (localStorage.getItem("access_token") !== null) {
    dispatch(
      GlobalStatusAction({
        IsLogedIn: true,
        Email: localStorage.getItem("Email"),
      })
    );
  }
  const IsLogin = useSelector((state) => state.GlobalStatus.data);
  return (
    <Router>
      <NavBar/>
      <Routes>
        <Route path="/" element={<Gallery/>} />
        <Route path="/About" element={<About />} />
        {IsLogin["IsLogedIn"] ? (
          <Route path="/Cart" element={<Cart/>} />
        ) : null}
        {IsLogin["IsLogedIn"] ? (
          <Route path="/Order" element={<Order/>} />
        ) : null}
        {IsLogin["IsLogedIn"] ? (
          <Route path="/Cart" element={<Cart/>} />
        ) : null}
        {(IsLogin["Email"] === "chintanmungra.chintan@gmail.com" || IsLogin["Email"] === "ami.gadhiya64@gmail.com") ? (
          <>
            <Route path="/AdminUpdateGallery" element={<UpdateGallery/>} />
            <Route path="/AdminCustomerOrders" element={<CustomerOrders/>} />
          </>
        ) : null}
      </Routes>
    </Router>
  );
}

export default App;